import { render, staticRenderFns } from "./form-edit-boards.vue?vue&type=template&id=c093cebe&"
import script from "./form-edit-boards.vue?vue&type=script&lang=js&"
export * from "./form-edit-boards.vue?vue&type=script&lang=js&"
import style0 from "./form-edit-boards.vue?vue&type=style&index=0&id=c093cebe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports